import { useState } from 'react';
import { FaDownload, FaTimes } from 'react-icons/fa';
import { useGetApkConfigQuery } from '@/store/api/systemApi';
import { isNativeApp } from '@/utils/platform';

const DownloadApkPopup = () => {
  // dismiss is in-memory only → on refresh the popup shows again
  const [visible, setVisible] = useState(true);

  // Already inside the installed APK — don't ask them to install it again.
  const inApp = isNativeApp();

  // The build no longer ships a hardcoded link: the bar serves whatever APK the
  // admin uploaded under App Management, and hides when they turn it off or
  // haven't uploaded one — otherwise it points at a file that isn't there.
  const { data: apk } = useGetApkConfigQuery(undefined, { skip: inApp });

  if (inApp) return null;
  if (!visible) return null;
  if (!apk?.isEnabled || !apk.apkUrl) return null;

  return (
    <div className="apk-popup">
      <style>{`
        .apk-popup {
          position: fixed;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 70;
          display: flex;
          align-items: stretch;
          justify-content: space-between;
          box-shadow: 0 -2px 12px rgba(0,0,0,0.25);
        }
        .apk-btn {
          flex: 1;
          min-width: 0;
          display: flex;
          align-items: center;
          gap: 10px;
          background: rgba(17,17,17,0.92);
          color: #fff;
          padding: 13px 16px;
          font-family: 'Roboto', sans-serif;
          font-size: 14px;
          font-weight: 700;
          letter-spacing: 0.3px;
          text-decoration: none;
          cursor: pointer;
          transition: background .15s ease;
        }
        .apk-btn:hover { background: rgba(17,17,17,0.98); }
        .apk-btn svg { flex-shrink: 0; }
        .apk-close {
          flex-shrink: 0;
          width: 56px;
          background: #e21f26;
          color: #fff;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: background .15s ease;
        }
        .apk-close:hover { background: #c41a20; }
      `}</style>

      {/* Download APK — triggers the APK download */}
      <a
        href={apk.apkUrl}
        download
        target="_blank"
        rel="noopener noreferrer"
        className="apk-btn"
      >
        <FaDownload size={16} />
        Download APK{apk.version ? ` v${apk.version}` : ''}
      </a>

      {/* Close — dismiss for this session (comes back on refresh) */}
      <button className="apk-close" onClick={() => setVisible(false)} aria-label="Close">
        <FaTimes size={18} />
      </button>
    </div>
  );
};

export default DownloadApkPopup;
